import { render } from "./Dashboard.vue?vue&type=template&id=697821b5&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dashboard.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Management/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "697821b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('697821b5', __exports__)) {
    console.log('reload')
    api.reload('697821b5', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=697821b5&ts=true", () => {
    console.log('re-render')
    api.rerender('697821b5', render)
  })

}


export default __exports__